import styled from 'styled-components';

const Line = styled.div`
  background-color: ${(props) => props.theme.lightGrey.string()};
  display: inline-block;
  height: 1px;
  width: 90px;
`;

const Or = styled.div`
  color: ${(props) => props.theme.lightGrey.string()};
  margin: auto 1rem;
`;

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 1rem auto;
`;

export function FacebookSeparator() {
  return (
    <Wrapper>
      <Line />
      <Or>or</Or>
      <Line />
    </Wrapper>
  );
}
